import MojitoServices from 'mojito/services';
import MojitoPresentation from 'mojito/presentation';
import PotentialReturns from 'modules/betslip/betslip-view/potential-returns/index.js';
import MatchAccaBetContent from 'modules/betslip/betslip-view/match-acca-bet-content/index.js';
import DefaultBetContent from 'modules/betslip/betslip-view/default-bet-content/index.js';
import OddsBoostBanner from 'modules/betslip/betslip-view/odds-boost-banner/index.js';
import BetBonusPromotions from 'modules/bet-bonus-promotions/index.js';

const { AbsolutePane, FlexPane, FormattedText } = MojitoPresentation.Components;
const { FormattedLabelWithPrice } = FormattedText;
const { BET_WAY, LEG_SORT } = MojitoServices.Bets.types;
const { utils: BetslipUtils, types: BetslipTypes } = MojitoServices.Betslip;

const SingleBet = props => {
    const {
        mojitoTools: { stringResolver, config },
        suspended,
        expired,
        highlight,
        bet,
        hasHcapChange,
        showBanker,
        isBankerPending,
        betslipStatus,
        betStake,
        betslip,
        hasOddsChange,
        showEachWay,
        showStake,
        onStakeInputFocus,
        onSelectionInfoClick,
        cbRemoveBet,
        forceEWLabelsToShow,
        showPotentialReturns,
        currencyCode,
        suspendedParts,
        isTeaser,
        hasPendingBonus,
    } = props;

    const isBetEachWay = forceEWLabelsToShow || betStake.betWay === BET_WAY.EACH_WAY;
    const selectionsLine = bet.parts.map(part => part.selectionId).join('_');
    const isBetBuilderBet = BetslipUtils.isBetBuilderBet(bet);

    const commonContentProps = {
        bet,
        suspended,
        expired,
        hasHcapChange,
        hasOddsChange,
        showEachWay,
        showStake,
        onStakeInputFocus,
        betStake,
        cbRemoveBet,
        isBetEachWay,
    };

    const isMatchAcca = LEG_SORT.BET_BUILDER === bet.legSort || LEG_SORT.MATCH_ACCA === bet.legSort;
    const shouldShowOddsBoostBanner =
        betslip.activeStakeGroup === BetslipTypes.STAKE_GROUP_NAME.SINGLES && bet.oddsBoostToken;

    return (
        <div
            className={`ta-SingleBetContainer ta-selectionId_${selectionsLine}`}
            style={isBetBuilderBet ? config.betBuilderContainer : config.betslipBet.container}
        >
            {highlight && !isMatchAcca && (
                <AbsolutePane
                    class="ta-highlightIndicator"
                    config={config.betslipBet.highlightIndicator}
                />
            )}

            {isMatchAcca ? (
                <MatchAccaBetContent
                    {...commonContentProps}
                    betslip={betslip}
                    config={config.betContent.matchAcca}
                    suspendedParts={suspendedParts}
                />
            ) : (
                <DefaultBetContent
                    {...commonContentProps}
                    config={config.betContent.default}
                    showBanker={showBanker}
                    isBankerPending={isBankerPending}
                    betslipStatus={betslipStatus}
                    isTeaser={isTeaser}
                    onSelectionInfoClick={onSelectionInfoClick}
                />
            )}
            <FlexPane config={config.potentialReturnsAndBonusesContainer}>
                <BetBonusPromotions
                    config={config.betBonusPromotions}
                    isActive={!hasPendingBonus}
                    currencyCode={currencyCode}
                    bonuses={bet.bonuses}
                />
                {!suspended && !expired && (
                    <PotentialReturnInfo
                        showStake={showStake}
                        showPotentialReturns={showPotentialReturns}
                        betStake={betStake}
                        config={config}
                        stringResolver={stringResolver}
                        currencyCode={currencyCode}
                    />
                )}
            </FlexPane>
            {shouldShowOddsBoostBanner && (
                <OddsBoostBanner
                    config={config.oddsBoostBanner}
                    oddsBoostToken={bet.oddsBoostToken}
                    betId={bet.id}
                    betWay={betStake.betWay || BET_WAY.WIN}
                    legSort={bet.legSort}
                    currencyCode={currencyCode}
                />
            )}
        </div>
    );
};

const PotentialReturnInfo = props => {
    const { showStake, showPotentialReturns, betStake, config, stringResolver, currencyCode } =
        props;

    if (!showStake || !showPotentialReturns) {
        return null;
    }

    const { payout = 0, payoutTax = 0 } = betStake;
    return (
        <FlexPane config={config.betslipBet.returnsContainer} class="ta-SingleBetReturnsContainer">
            <PotentialReturns
                config={config.potentialReturns}
                potentialReturns={payout}
                currencyCode={currencyCode}
            />
            {!showStake || payoutTax === 0 ? null : (
                <FormattedLabelWithPrice
                    label={stringResolver.resolveString('$BETSLIP.POTENTIAL_TAX')}
                    price={payoutTax}
                    currency={currencyCode}
                    config={config.potentialTax}
                    class="ta-SingleBetPotentialTax"
                />
            )}
        </FlexPane>
    );
};

export default SingleBet;
